import { AxiosResponse } from 'axios';
import api from './Api'

export const getReward = (): Promise<AxiosResponse<IReward, any>> => {
    return api.get(`/reward`)
}
